import { render, staticRenderFns } from "./EditPayPlanChangeRequest.vue?vue&type=template&id=32f565d9&scoped=true"
import script from "./EditPayPlanChangeRequest.vue?vue&type=script&lang=ts"
export * from "./EditPayPlanChangeRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f565d9",
  null
  
)

export default component.exports